export default __webpack_public_path__ + "static/lock-e6e19aca245a91188f8675800c29c1b7.png";